import { render, staticRenderFns } from "./email-unverified-page.vue?vue&type=template&id=58df8c8a&"
import script from "./email-unverified-page.vue?vue&type=script&lang=js&"
export * from "./email-unverified-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports